import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    error: false,
    files: null,
    filesMeta: {},
}); };
function mediaReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'MEDIA_LOAD_FILES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'MEDIA_LOAD_FILES_SUCCESS':
                state.files = action.files || null;
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case 'MEDIA_LOAD_FILES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default mediaReducer;
